// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3DK9g","noInteraction":"EventWrapper_noInteraction__CGJrm"};